<script setup lang="ts">
/**
 * Colour-scheme choice auto, light, dark (ADR-076, design prototype): three icon buttons in a
 * capsule, the pressed one is the current choice. Same look and contract as the website's
 * picker (apps/astro/src/components/astro/ThemePicker.astro); state in src/lib/theme.ts.
 */
import { THEME_PREFERENCES, useTheme, type ThemePreference } from "../lib/theme.ts";

const labels: Record<ThemePreference, string> = {
  auto: "Darstellung wie das System",
  light: "Helle Darstellung",
  dark: "Dunkle Darstellung",
};

const { preference, setPreference } = useTheme();
</script>

<template>
  <div
    class="rounded-pill border-line inline-flex gap-0.5 border bg-(--color-surface) p-0.75"
    role="group"
    aria-label="Darstellung"
  >
    <button
      v-for="option in THEME_PREFERENCES"
      :key="option"
      type="button"
      class="rounded-pill text-text-soft ease-brand hover:text-text-head focus-visible:outline-focus aria-pressed:bg-accent-bg aria-pressed:text-accent-text inline-flex size-(--size-control) cursor-pointer items-center justify-center transition-colors duration-(--duration-hover) focus-visible:outline-2 focus-visible:outline-offset-1 motion-reduce:transition-none pointer-coarse:size-(--size-button)"
      :aria-pressed="preference === option"
      :title="labels[option]"
      :data-theme-option="option"
      @click="setPreference(option)"
    >
      <span class="sr-only">{{ labels[option] }}</span>
      <svg
        class="size-4.5"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <template v-if="option === 'auto'">
          <circle cx="12" cy="12" r="8.5" />
          <path d="M12 3.5a8.5 8.5 0 0 1 0 17z" fill="currentColor" stroke="none" />
        </template>
        <template v-else-if="option === 'light'">
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2v2m0 16v2M4.9 4.9l1.4 1.4m11.4 11.4 1.4 1.4M2 12h2m16 0h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
        </template>
        <path v-else d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
      </svg>
    </button>
  </div>
</template>
